import { useEffect, useState } from "react";
import { API } from "../lib/api";
import { User } from "lucide-react";

const cache = new Map(); // path -> blobUrl

export default function Avatar({ path, name = "", size = 36, className = "" }) {
  const [url, setUrl] = useState(() => (path ? cache.get(path) : null) || null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setErr(false);
    if (!path) {
      setUrl(null);
      return;
    }
    if (cache.has(path)) {
      setUrl(cache.get(path));
      return;
    }
    let cancelled = false;
    const token = localStorage.getItem("ubbs_token");
    fetch(`${API}/files/${path}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) throw new Error("img " + r.status);
        return r.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        const u = URL.createObjectURL(blob);
        cache.set(path, u);
        setUrl(u);
      })
      .catch(() => !cancelled && setErr(true));
    return () => {
      cancelled = true;
    };
  }, [path]);

  const initials = (name || "")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const baseStyle = { width: size, height: size };
  const placeholder = (
    <div
      className={`inline-flex items-center justify-center bg-white/70 glass-panel font-mono text-[10px] tracking-widest text-neutral-600 ${className}`}
      style={baseStyle}
      data-testid="avatar-placeholder"
    >
      {initials || <User className="h-4 w-4 text-neutral-400" />}
    </div>
  );

  if (!path || err) return placeholder;

  return (
    <div
      className={`inline-block bg-white/70 glass-panel overflow-hidden ${className}`}
      style={baseStyle}
      data-testid="avatar"
    >
      {url ? (
        <img src={url} alt={name || "avatar"} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full animate-pulse" />
      )}
    </div>
  );
}
